<h2 mat-dialog-title>Recovery Agent Details</h2>

<mat-dialog-content>
  <div class="view-grid">
    <div class="view-field">
      <span class="view-label">RA Mailing Name</span>
      <span class="view-value">{{ data.RAMailingName || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Street 1</span>
      <span class="view-value">{{ data.Street1 || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Street 2</span>
      <span class="view-value">{{ data.Street2 || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">City</span>
      <span class="view-value">{{ data.City || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">State</span>
      <span class="view-value">{{ data.State || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Zip Code</span>
      <span class="view-value">{{ data.ZipCode || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Zip Plus 4</span>
      <span class="view-value">{{ data.ZipPlus4 || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Paperless Indicator</span>
      <span class="view-value">{{ data.PaperlessInd || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Tax ID</span>
      <span class="view-value">{{ data.RecoveryAgentTaxID || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">External Org</span>
      <span class="view-value">{{ data.ExternalOrg || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Operating Company</span>
      <span class="view-value">{{ data.OperatingCompany || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Office Key</span>
      <span class="view-value">{{ data.OfficeKey || '—' }}</span>
    </div>

    <div class="view-field">
      <span class="view-label">Last Updated By</span>
      <span class="view-value">{{ data.LastUpdatedBy || '—' }}</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="onClose()">Close</button>
</mat-dialog-actions>
